import { apiFetcher } from '@/config/api-fetcher.config';
import type { GetProject } from '@/server/api/rest/project/project-repository.ssr';
import {
  isJsonApiSuccessResponse,
  type JsonApiResponse,
} from '@httpx/json-api';

export const fetchProject = async (slug: string): Promise<GetProject> => {
  return apiFetcher<JsonApiResponse<GetProject>>(
    `/api/rest/project/${slug}`
  ).then((resp) => {
    if (!isJsonApiSuccessResponse(resp)) {
      throw new Error(
        // @todo improve error reporting
        `Error fetching projects: ${JSON.stringify(resp?.errors ?? '')}`
      );
    }
    return resp.data;
  });
};
